import React from "react";
import { UsageSelectorContainer } from "./style";
import NumberFormat from "components/numberFormat";
const UsageSelector = ({ usages, onChange, selected }) => {
  return (
    <UsageSelectorContainer>
      <h5>انتخاب کاربری</h5>
      {usages.map((usage) => (
        <div
          className={`item ${selected?.id === usage.id ? "selected" : ""}`}
          key={usage.id}
          onClick={() => onChange({ usage: usage })}
        >
          <div className="title-area">{usage.description}</div>
          <div className="price">
            {usage.added_price ? (
              <NumberFormat value={usage.added_price} />
            ) : (
              ""
            )}
          </div>
        </div>
      ))}
      <div className="notice">
        تهیه کاربری و کلیه هزینه های آن بر عهده خریدار می باشد
      </div>
    </UsageSelectorContainer>
  );
};
export default UsageSelector;
